<template>
    <label class="start-new-imprint__label" for="imprint-types">
        {{ activeImprintTypeID === 3 ? "Step 2: " : '' }}Upload an Image
    </label>
    <ul class="clist-table clist-table--titles clist-style--none">
        <li class="clist-table__row clist-table__row--two-cols clist-table__row--uploads">
            <div class="clist-table__col clist-table__col--upload-image">
                <input
                    :class="['imprint-types__upload-btn', customBackground, customBackgroundHover]"
                    id="imprint-types-upload-btn"
                    type="file"
                    @change="onFileSelected"
                    style="display: none"
                    ref="fileInput"
                >
                <button :class="['imprint-types__upload-btn', customBackground, customBackgroundHover]" @click="$refs.fileInput.click()">Choose file</button>
                <span class="uploaded-file-name" :title="selectedFile ? selectedFile.name : 'No file chosen'">
                    {{ selectedFile ? selectedFile.name : 'No file chosen' }}
                </span>
                <!--button class="imprint-types__upload-btn" @click="onUpload">Upload</button -->
            </div>
            <div class="clist-table__col clist-table__col--upload-accepted">
                <p class="imprint-text-bold">Accepted file types:</p>
                <span style="font-weight: 300; font-size: 14px;">{{ acceptedFiles }}</span>
            </div>
        </li>
        <li v-if="message" class="success">
          <p class="remove-file" @click="removeFile">Remove</p>
          <p class="message">{{ message }}</p>
        </li>
        <li v-if="errors" class="error">
          <p>{{ errors[0] }}</p>
        </li>
    </ul>
</template>

<script>
import { store } from './store.js';
import axios from 'axios';

export default {
    props: {
        activeImprintTypeID: Number
    },
    data() {
        return {
            store: store,
            acceptedFiles: '',
            selectedFile: null,
            images: [],
            //upload_base_url: "https://imprint-uploads.s3.ca-central-1.amazonaws.com/uploads",
            apiBaseUrl: "https://dev.api-customapp.comda.com/",
            endpoint: "api/upload/imprint",
            endpoint_s: "api/helloworld",
            message: "",
            errors: []
        }
    },
    computed: {
        customColor() {
            return this.$getCustomColorClass(store.storeID);
        },
        customColorBefore() {
            return this.$getCustomColorBeforeClass(store.storeID);
        },
        customColorAfter() {
            return this.$getCustomColorAfterClass(store.storeID);
        },
        customFont() {
            return this.$getCustomFontClass(store.storeID);
        },
        customBackground() {
            return this.$getCustomBackgroundColorClass(store.storeID);
        },
        customBackgroundHover() {
            return this.$getCustomBackgroundColorHoverClass(store.storeID);
        }
    },
    methods: {
        init() {
            if(window.PXUTheme.theme_settings.api_beckend_url) {
                this.apiBaseUrl = window.PXUTheme.theme_settings.api_beckend_url;
            }
            this.acceptedFiles = this.getAcceptedFileTypes();
            this.selectedFile = this.store.selectedLastStep[this.store.imprintKey].uploaded_image != null ? this.store.selectedLastStep[this.store.imprintKey].uploaded_image.file : null;
            this.message = this.store.selectedLastStep[this.store.imprintKey].messageUpload != null ? this.store.selectedLastStep[this.store.imprintKey].messageUpload : null;
            //this.store.inputProductData;
        },
        getAcceptedFileTypes() {
            return 'ai, bmp, cdr, eps, jpeg, jpg, pdf, png, tiff';
        },
        onFileSelected(event){
            console.error("this images before validation >>>>");
            console.warn(this.$refs.fileInput.files[0]);

            if(!this.validateImage(event.target.files[0])){

              return false;
            }

            this.selectedFile = event.target.files[0];
            this.store.selectedLastStep[this.store.imprintKey].uploaded_image = { file : event.target.files[0], href: null };
            this.images = this.$refs.fileInput.files[0];
            this.submitFile();
            console.error("Upload Event");
            console.log(event);
            console.log(this.selectedFile);



           // this.$emit('uploadChnaged', event.target.files[0]);
        },

        validateImage(file){
           // let allowedTypes = [ 'application/illustrator','image/ai','image/bmp','image/cdr','image/x-eps','image/jpeg',' image/jpg', 'image/png','image/pdf','image/tiff'];
            let allowedTypesByName = [ '.ai','.bmp','.cdr','.eps','.jpeg','.jpg', '.png','.pdf','.tiff'];
            this.errors = [];
/*
            if (!allowedTypes.includes(file.type)) {
                this.errors.push('Invalid file type. Only ai, bmp, cdr, eps, jpeg, jpg, pdf, png, tiff are allowed.');
            }
*/
            console.warn('validate file');
            console.warn(file);
            let file_name = '';
            let file_name_type = '';
            if(this.$refs.fileInput.files[0] && this.$refs.fileInput.files[0]['name']) {
              file_name = this.$refs.fileInput.files[0]['name'];

              let splitNameByDot = file_name.split('.');
              if(splitNameByDot.length > 0) {
                file_name_type = '.' + splitNameByDot[splitNameByDot.length - 1]; // png,ipg,pdf
              }
            }

            if (!allowedTypesByName.includes(file_name_type)) {
              this.errors.push('Invalid file type. Only ai, bmp, cdr, eps, jpeg, jpg, pdf, png, tiff are allowed.');
            }
            if(this.$refs.fileInput.files[0].size > (1024 * 1024 * 24)) {
                console.error(" File to large ");
                this.errors.push('The file you are uploading is too large. The maximum file size is 24MB. Please upload a different file.');
            }

            if(this.errors.length>0){
            return false;
            }

            return true;
        },

        submitFile() {
            const formData = new FormData();
            let file_type = '';
            let file_name = '';
            let file_name_type = '';

            if(this.$refs.fileInput.files[0] && this.$refs.fileInput.files[0]['type']) {
                file_type = this.$refs.fileInput.files[0]['type']; 
            }

            if(this.$refs.fileInput.files[0] && this.$refs.fileInput.files[0]['name']) {
              file_name = this.$refs.fileInput.files[0]['name'];

              let splitNameByDot = file_name.split('.');
              if(splitNameByDot.length > 0) {
                file_name_type = '.' + splitNameByDot[splitNameByDot.length - 1]; // png,ipg,pdf
              }
            }
             
            console.error("this images >>>>");
            console.warn(this.$refs.fileInput.files[0]);
            formData.append('file_type', file_type);
            formData.append('file_name', file_name);

            if(file_name_type) {
              formData.append('file_name_type', file_name_type);
            }

            formData.append('image', this.$refs.fileInput.files[0]);
            formData.append('_method', 'PUT');
            let response = null;

                response = axios.post(
                        this.apiBaseUrl + this.endpoint,
                        formData,
                        {
                            headers: {
                                'Content-Type': 'multipart/form-data',
                                //'Accept': '*/*'
                            }
                        }
                    ).then(
                    (res) => {
                        console.error(" axios result >>>");
                        console.log(res);
                        console.log(res.data);
                        console.log(res.data.urlFromStorage);
                        this.store.selectedLastStep[this.store.imprintKey].uploaded_image.href = res.data.urlFromStorage;
                        res.data.files; // binary representation of the file
                        res.status; // HTTP status
                        this.$emit('uploadChanged', {'imageUploaded': true, 'uploadMessage': 'Image Uploaded Successfully! '});
                        this.message = "Image Uploaded Successfully!";
                        this.store.selectedLastStep[this.store.imprintKey].messageUpload = this.message
                    }
                ).catch(
                error => {
                    console.error("upload error");
                    console.error(error);
                }
                );

            return response;
        },

        removeFile(){
          this.$refs.fileInput.value = '';
          this.selectedFile = null;
          this.message = "";
          this.store.selectedLastStep[this.store.imprintKey].uploaded_image = null;
          this.store.selectedLastStep[this.store.imprintKey].messageUpload = null
        },
        /*onUpload(e) {
            console.log("onUpload");
            console.log(e);
            const fb = new FormData();
            fb.append('image', this.selectedFile, this.selectedFile.name);
        }*/
    },
    created() {
        this.init();
    }
}
</script>

<style>
.success .remove-file{
  font-family: "Montserrat", sans-serif;
  font-size: 14px;
  font-weight: 400;
  color: #E83223;
  cursor: pointer;
}
.success .message{
  color: #11B400;
  font-weight: bold;
  font-size: 14px;
  font-family: museo-sans, sans-serif;
  line-height: 21px;
}
.error p {
  color: #E83223;
  margin: 0;
  font-size: 13px;
}
.clist-table__row.clist-table__row--uploads {
    display: flex;
}
.uploaded-file-name {
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    padding-left: 4px;
    max-width: 100%;
    color:#898989;
    font-family: 'Open Sans', sans-serif;
}
.clist-table__col.clist-table__col--upload-image {
    width: 50%!important;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
}
.clist-table__col.clist-table__col--upload-accepted {
    width: auto!important;
    padding-left: 5px;
}

.clist-table__col.clist-table__col--upload-accepted{
  color: #5A5A5A;
  font-family: 'Open Sans', sans-serif;
}
.clist-table__col.clist-table__col--upload-accepted span{
  font-size: 14px;
  font-weight: 300;
}
.clist-table__col.clist-table__col--upload-accepted p {
  font-size: 12px;
  font-weight: 600;
  margin-bottom: 0;
}

.comda .clist-table__col.clist-table__col--upload-accepted p{
    color:#0072BC;
}

</style>